// extracted by mini-css-extract-plugin
module.exports = {"content":"client_content__2bxQf","half_module":"client_half_module__mhhGw","vacation_table":"client_vacation_table__1nBqG","pointer":"client_pointer__3PLf0"};